import { Event } from "@mui/icons-material"
import { Box, Button, Paper, Popover, useTheme } from "@mui/material"
import { format, subMonths } from "date-fns"
import { useRef, useState } from "react"
import { DateRange, DateRangeProps } from "react-date-range"
import { DATE_FORMAT } from "app/date"

import "react-date-range/dist/styles.css"
import "react-date-range/dist/theme/default.css"

interface DateRangePickerValues {
  startDate?: Date
  endDate?: Date
}

interface DateRangePickerProps {
  values: DateRangePickerValues
  onChange: (values: DateRangePickerValues) => void
  dateRangeProps?: DateRangeProps
}

export const DateRangePicker = ({ values, onChange, dateRangeProps }: DateRangePickerProps) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef()

  const theme = useTheme()

  const handleClick = () => setOpen((open) => !open)

  return (
    <Box ref={anchorRef}>
      <Button variant="outlined" onClick={handleClick}>
        {(values.startDate && format(values.startDate, DATE_FORMAT)) ?? "..."}
        &nbsp;-&nbsp;
        {(values.endDate && format(values.endDate, DATE_FORMAT)) ?? "..."}
        &nbsp;
        <Event />
      </Button>

      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={anchorRef.current}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Paper>
          <DateRange
            onChange={({ selection }) =>
              onChange({ startDate: selection?.startDate, endDate: selection?.endDate })
            }
            months={3}
            ranges={[
              {
                ...values,
                key: "selection",
              },
            ]}
            rangeColors={[theme.palette.primary.main]}
            direction="horizontal"
            dateDisplayFormat={DATE_FORMAT}
            showDateDisplay={false}
            shownDate={subMonths(values.endDate ?? new Date(), 2)}
            dragSelectionEnabled={false}
            preventSnapRefocus={true}
            {...dateRangeProps}
          />
        </Paper>
      </Popover>
    </Box>
  )
}
